import { Component } from "vue-property-decorator";
import WebSocket from "./websocket";
import GISagroBase from "./gisagro.base";
import Map from "@/components/map/Map";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";

import { IMapViewInfo, IMapAction, IFeatureInfo, IGeoJSON, 
         IInfoSchema, IInfoProperty, ICodeList, IThaiArea, 
         Extent, IFeatureToSave, IFeatureToSaveByIntersects
        } from "@/components/map/types";
import { getAuthorizedLayers, afterModified, afterMoved, 
         selectSplitTargets, afterSplitted, afterCut, 
         afterDeleted,
         MAX_RESOLUTION_4_EDITING } from "./data/farmland";
import { User } from "@/components/User";
import { base64toBlob } from "@/components/shared/Exif";

import { L } from "@/common/filters";

import { setTimeout } from 'timers';
import { isString, isArray, isObject, parseValue, isJsObject } from '@/common/utils';
import { Agritronics, AgritronicsPhase2, WaterStation } from "./data/map.layers";
const LAND_SCHEMA = require("../../public/static/js/schemas").default;

let shp = require("shpjs");

type EDrawerHelperPage = "" | "help" | "profile" | "user_profile" | "online_users" | 
  "admin_users" | "admin_adduser" | "admin_userlogs";
interface IIconTool {
  divider?: boolean;
  name?: string;
  icon?: string;
  icon2?: string;
  color?: string;
  class?: string;
}
//import MapTools from "../components/map/Tools";
const MAP_TOOLS = [
  {	name: 'undo',
    title: 'Undo',
    icon: 'undo',
    isEnabled: false
  },
  {	name: 'redo',
    title: 'Redo',
    icon: 'redo',
    isEnabled: false
  },
  {	name: 'save',
    title: 'บันทึกข้อมูล',
    icon: 'save',
    isEnabled: false  // will be changed when a feature is changed
  },
  { divider: true },
  /*reserved
  {	name: 'linkData',
    title: 'เชื่อมโยงข้อมูลแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'selectByPolygon',
    title: 'เลือกหมุดในโพลีกอน',
    isMapTool: true
  },
  {	name: 'selectNone',
    title: 'ลบขอบเขตเลือกหมุด',
    isMapTool: true
  },
  { divider: true },*/
  {	name: 'addPoint',
    title: 'สร้างหลักหมุดของแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15 //these command are only enabled when map zoom level >= enabledZoomLevel
  },
  /* reserved
  {	name: 'addPointXY',
    title: 'สร้างหมุดด้วยค่าพิกัด',
    isMapTool: true,
    isEditTool: true,
    isEnabled: false, // depending on map zoom level
  },
  {	name: 'addPointAzimuthDistance',
    title: 'สร้างหมุดด้วยระยะห่างและมุม Azimuth',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'addPointBearingDistance',
    title: 'สร้างหมุดด้วยระยะห่างและมุม Bearing',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'addPointDxDy',
    title: 'สร้างหมุดด้วยระยะห่าง dX,dY',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'addPointA2BDistance',
    title: 'สร้างหมุดด้วยระยะห่างจากจุด A ไปจุด B',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'addPolygonXY',
    title: 'สร้างแปลงจากพิกัด',
    isMapTool: true,
    isEditTool: true
  },*/
  {	name: 'createConvexHull',
    title: 'เลือกหมุดสร้างแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'addPolygon',
    title: 'สร้างแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  { divider: true },
  {	name: 'modifyFeature',
    title: 'แก้ไขพิกัดแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'moveFeature',
    title: 'ย้ายตำแหน่ง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'indian75ToWgs84',
    title: 'แก้พิกัดจาก Indian 1975',
    isMapTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'cutPolygonHole',
    title: 'ตัดกลางแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'splitPolygon',
    title: 'แบ่งแยกแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  /*reserved
  {	name: 'scalePolygonArea',
    title: 'กำหนดเนื้อที่ของแปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'transformPolygon',
    title: 'ขยาย/ย่อ/หมุน แปลง',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },*/
  {	name: 'deleteFeature',
    title: 'ลบข้อมูล',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  {	name: 'deleteFeatures',
    title: 'ลบข้อมูลในโพลีกอน',
    isMapTool: true,
    isEditTool: true,
    enabledZoomLevel: 15
  },
  { divider: true },
  {	name: 'uploadLand',
    title: 'อัพโหลดแปลง',
    icon: 'cloud_upload',
    type: 'file',
    accept: '.gpx,.zip',
    isEditTool: true
  }];

const END_USER_MENUS = [{
    name: 'help', 
    icon: 'picture_as_pdf',
    title: 'helpManual'
  }];

const ADMIN_MENUS = [{
    name: 'admin_users',
    icon: 'supervised_user_circle',
    title: 'systemAdmin'
  }];

const LOGOUT_MENUS = {
    name: 'logout',
    title: 'logout',
    icon: 'exit_to_app',
    page: 'home'
  };

@Component
export default class GISagroLandClass extends GISagroBase {
  DrawerHeight: number = 0;
  //mapLayers: IMapLayer[] = null;

  AdminTabs: string = "USERS";
  showSpeedTester: boolean = false;
  showSpeedTesterAt: string = null;
  showUploader: boolean = false;
  showUploaderAt: string = null;
  timeNow: string = null;
  clockInterval: NodeJS.Timer = null;

  showDrawerLeft: boolean = false;
  showDrawerLeftLast: boolean = true;
  showDrawerRight: boolean = false;
  showDrawerRight2: boolean = false;
  DrawerHelperPage: EDrawerHelperPage = ''; // important since we use .math() for v-if
  
  tools: {[key:string] : any} = MAP_TOOLS;
  menus: {[key:string] : any} = END_USER_MENUS;
  menuLogout: {[key:string] : any} = LOGOUT_MENUS;

  // for left side drawer
  toc: "SEARCH" | "DOWNLOAD" | "MAP_INFO" | "LINK_DATA" = null;
  srhDataSource: "GISagro" | "DOL" | "PLACE" = 'GISagro';

  srhShowOptions: boolean = true;
  srhShowAdminAreas: boolean = true;
  srhShowCropTypes: boolean = false;
  srhShowDeedTypes: boolean = false;
  srhShowYears: boolean = false;
  srhShowLandAreas: boolean = false;
  srhLandsInSelectedAdminArea: number = null;
  srhLandsOfSelectedCropType: number = null;
  srhLandsOfSelectedDeedType: number = null;
  srhLandsOfSelectedYear: number = null;
  srhLandsOfSelectedArea: number = null;
  srhSelectedCropFamily = null;
  srhSelectedCropType = null;
  srhSelectedCropSpecies = null;
  srhSelectedDeedType = null;
  shrSelectedGrowOrHarvest: "grow" | "harvest" | "" = '';
  srhShowGrowHarvestYearPicker: boolean = false;
  srhSelectedGrowHarvestYear: number = null;
  srhSelectedAreaType: "lte" | "gte" | "between" = null;
  srhSelectedArea1: IThaiArea = {
    Rai: null,
    Ngan: null,
    SqWah: null
  };
  srhSelectedArea2: IThaiArea = {
    Rai: null,
    Ngan: null,
    SqWah: null
  };
  showSearchResults: boolean = true;
  hasSearchResults:boolean = false;
  searchResults: {[key:string] : any} = null;
  SearchKeyword: string = null;
  DrawerHelperSearchKeyword: string = null;
  isSearching: boolean = false;
  
  srhCropFamilies: ICodeList[] = [];
  srhCropTypes: ICodeList[] = [];
  srhCropSpecies: ICodeList[] = [];
  srhDeedTypes: ICodeList[] = [];
  isLoadingCropFamilies: boolean = false;
  isLoadingCropTypes: boolean = false;
  isLoadingCropSpecies: boolean = false;
  isLoadingDeedTypes: boolean = false;

  WebSocket: WebSocket = new WebSocket();

  initialize() {
    // called from created() in gisagro.land.vue
    this.fetchProvinces();
    this.measurerIndex = 1;
    this.measurer = this.measurerStore.lists[this.measurerIndex];
    this.measureUnit = 'thai';
    this.measureCrs = 'WGS84';
    try {
    this.fetchPageView('gisagro.land');
    } catch (error) {}
    try {
      this.fetchCropSuitability();
    } catch(error) {}
  }

  async fetchSdsData() {
    try {
      let ok = await this.sds.login('gisagro40','GISagro4.0');
      if (ok) {
        ok = await this.sds.fetchData();
        if (ok) {
          let stations = this.sds.Stations;
          [ Agritronics, AgritronicsPhase2, WaterStation ].forEach((station,index) => {
            let s = stations[index+1];
            let features = [];
            for (let i=0; i<s.length; i++) {
              features = features.concat(
                this.$map.GeoJSONToFeatures(s[i].GeoJSON, {
                  dataProjection: 'EPSG:4326',
                  featureProjection: 'EPSG:3857'
                })
              );
            }
            let source:VectorSource = <VectorSource> station.nativeLayer.getSource();
            if (source['source']) { // source of Clustering
              source = source['source'];
            }
            source.clear();
            source.addFeatures(features);
          }, this);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  get MapViewPaddingLeft() : number {
    return this.showDrawerLeft ? this.TocWidth : 0;
  };

  get MapViewPaddingTop() : number {
    return 76;
  };

  get MapViewPaddingRight() : number {
    return this.showDrawerHelper ? 760 : 0;
  };

  get MapViewPaddingBottom() : number {
    return 0;
  };

  get MapViewPadding() : Extent {
    return [
      this.MapViewPaddingTop,
      this.MapViewPaddingRight,
      this.MapViewPaddingBottom,
      this.MapViewPaddingLeft
    ];
  };

  get ViewPadding() : {[key:string] : string} {
    return {
      'padding-left' : this.MapViewPaddingLeft + 'px!important',
      'padding-top' : '52px!important',
      'padding-right' : this.MapViewPaddingRight + 'px!important',
      'padding-bottom' : this.MapViewPaddingBottom + 'px!important'
    }
  };

  get showDrawerHelper() : boolean {
    return !this.showDrawerLeft && this.showDrawerRight2;
  }
  set showDrawerHelper(value:boolean) {
    // do nothing to avoid xxx has not setter
  }

  DateFormat() {
    return this.language=='th' ? 'dd-mm-yyyy' : 'yyyy-mm-dd';
  };

  // events
  onResize() {
    this.WindowWidth = window.innerWidth;
    this.DrawerHeight = window.innerHeight - 76;
    if (this.isSmallOrMobile) {
      this.TocWidth = 576;
    } else {
      this.TocWidth = 330;
    }
  };

  onMapCreated($map:Map) {
    // map is a full component from olMap, including the native olMap
    // BaseMaps, active action, ... and all methods to call
    this.$map = $map; // the same as this.$refs.map
    MAP_TOOLS.forEach((mt) => {
      if (mt.enabledZoomLevel!==undefined) {
        mt.enabledZoomLevel = this.$map.getZoomForResolution(MAX_RESOLUTION_4_EDITING);
      }
    });
    //let farmlands = getAuthorizedLayers(this.User);
    /*setTimeout(() => {
      this.$map.createOverlayLayersAndControls(farmlands);
      this.mapLayers = this.$map.map.MapLayers;
    },500);*/
  };

  getURLParameter(name:string) : string {
    let value = RegExp(name + '=(.+?)(&|$)').exec(location.search);
    return value ? decodeURI(value[1]) : null;
  }

  onBaseMapInitialized(event) {
    //this.$map.normalizeScale();
    if (!(this.User && this.User.hasLoggedIn)) {
      let token = this.getURLParameter('token');
      if (token) {
        this.login(token);
      } else {
        this.showUserLogin();
      }
    } else {
      setTimeout(() => {
        this.createFarmlandLayer()
      }, 250); // wait 250ms for basemap to show
    }
  }

  createFarmlandLayer() {
    if (this.ImAdmin) {
      this.menus = END_USER_MENUS.concat(ADMIN_MENUS);
    } else {
      this.menus = END_USER_MENUS;
    }
    if (!(this.mapLayers && this.mapLayers.length>0)) {
      let farmlands = getAuthorizedLayers(this.User);
      farmlands.forEach((layer, index) => {
        //layer.parent = mapLayerStoreRoot;
        layer.parent = null;
        layer.id = index + '';
        this.showMapLayer(layer);
      }, this);
      this.mapLayers = this.mapLayersOrdered;
      this.$map.createOverlayLayersAndControls(this.mapLayers);
    }
    this.showUserExtent();
    this.WebSocket.open();
  }

  showUserExtent() {
    if (this.User.ResponsibleAreaCode) {
      let code = this.User.ResponsibleAreaCode + '';
      if (code.length==6) {
        this.mapFilter.TambonCode = parseInt(code);
        this.mapFilter.AmphoeCode = parseInt(code.substr(0,4));
        this.mapFilter.ProvinceCode = parseInt(code.substr(0,2));
        this.zoomToTambon();
      } else if (code.length==4) {
        this.mapFilter.TambonCode = null;
        this.mapFilter.AmphoeCode = parseInt(code);
        this.mapFilter.ProvinceCode = parseInt(code.substr(0,2));
        this.zoomToAmphoe();
      } else if (code.length==2) {
        this.mapFilter.TambonCode = null;
        this.mapFilter.AmphoeCode = null;
        this.mapFilter.ProvinceCode = parseInt(code);
        this.zoomToProvince();
      }
    } else {
      this.mapFilter.ProvinceCode = null;
      this.mapFilter.AmphoeCode = null;
      this.mapFilter.TambonCode = null;
      this.zoomToProvince();
      this.clearFilter();
    }
  }

  onOpenBasemap(open:boolean) {
    this.BaseMapListIsOpen = open;
  }

  /**
   * viewInfo: IMapViewInfo
   */
  onViewChange(viewInfo: IMapViewInfo) {
    this.zoom = viewInfo.zoom;
    this.tools.forEach((tool) => {
      if (tool.enabledZoomLevel!=undefined) {
        tool.isEnabled = (viewInfo.zoom >= tool.enabledZoomLevel);
      }
    }, this);
  };

  async showUserDataMenu() {
    // such as for data submitted from DOAE farmer app
    try {
      if (this.User && this.User.hasLoggedIn) {
        let userData = this.$store.getters.UserData;
        switch ((this.User.Organization.Code+'').toLowerCase()) {
        case 'doae':
          
          break;
        }

      } 
                    
    } catch (error) {
      
    }
  }
 
  buildMapInfo(data:IGeoJSON) : IInfoSchema {
    let info:IInfoSchema;
    let title = data.featureClass + '';
    let schema:IInfoSchema; 
    let featureOnMap = data.featureOnMap
    let propsOfFeatureOnMap = featureOnMap ? featureOnMap.getProperties() : null;
    let canEdit:boolean = false;
    let p;
    if (data.features) {
      // todo: how to show each result
      data = data.features[0];
    }
    schema = title.match(/^farmland/i) ? LAND_SCHEMA : data.properties.schema;
    if (schema) {
      let callOnOptionChanges:{[key:string]:any}[] = [];
      let autoSearches:{[key:string]:any}[] = [];
      let crop = {
        type_fk_g: data.properties.type_fk_g,
        genus_fk_g: data.properties.genus_fk_g,
        crop_fk_g: data.properties.crop_fk_g
      };
      info = {
        title: schema.title || title || 'Featureinfo',
        feature: featureOnMap,
        saveOrder: schema.saveOrder,
        items: schema.items.map((item,itemIndex) => {
          return {
            group: item.group,
            properties: item.properties.map((prop, propIndex) => {
              let value:any = data.properties[prop.name];
              if (prop.dataType=='boolean') {
                // convert true/false to 1/0 otherwise null
                // this is required for v-radio-group control 
                // that does not support true/false as value
                value = (value===null || value===undefined) ? null : 
                        !!value ? 1 : 0;
              } else if (value && (prop.dataType=='date' || prop.ctrlType=='date')) {
                value = parseValue(value, 'date');
              }
              let originalValue:any = value;
              let props;
              if (propsOfFeatureOnMap && prop.name!='gid' && 
                propsOfFeatureOnMap.hasOwnProperty(prop.name) &&
                propsOfFeatureOnMap[prop.name]) {
                // update value from properties of the feature on map
                // ensure that originalValue has already been set before this point
                value = propsOfFeatureOnMap[prop.name];
              }

              // value in the following might have been changed from feature on map
              // ensure that originalValue has already been set before this point
              if (prop.name=='area_sqm') {
                value = parseFloat('0' + data.properties[prop.name]);
                value = (Math.round(value * 100) / 100).toThousandCommaString();
                originalValue = value; //wont to update area_sqm since this will be auto calcd in PG
              } else if (prop.name=='ssn_pk') {
                props = propsOfFeatureOnMap || data.properties;
                value = props.hasOwnProperty('fssn_fk') ? props['fssn_fk'] :
                        props.hasOwnProperty('farmer_ssn') ? props['farmer_ssn'] : null;
                if (!!value) {
                  let user = this.User;
                  let orgc = props['org_code'] || props['orgc_fk'];
                  if (!(user.isSuperAdmins || (
                      user.Organization && user.Organization.Code && orgc && 
                      user.Organization.Code.match(new RegExp(orgc,'i')) ||
                      user.NationalId==value))) {
                    value = null;
                  }
                }
              } else if (prop.name=='photo') {
                props = propsOfFeatureOnMap || data.properties;
                value = props.hasOwnProperty('ssn_pk') ? props['ssn_pk'] :
                        props.hasOwnProperty('fssn_fk') ? props['fssn_fk'] :
                        props.hasOwnProperty('farmer_ssn') ? props['farmer_ssn'] : null;
                this.resetMapInfoFarmerPhotoInput();
              } else if (prop.name=='deed_no_g') {
                props = propsOfFeatureOnMap || data.properties;
                value = value || props['deed_no'];
                if (!!value) {
                  let user = this.User;
                  let orgc = props['org_code'] || props['orgc_fk'];
                  if (!(user.isSuperAdmins || (
                      user.Organization && user.Organization.Code && orgc && 
                      user.Organization.Code.match(new RegExp(orgc,'i')) ||
                      user.NationalId==value))) {
                    value = null;
                  }
                }
              } else if (prop.name=='hrn_pk') {
                props = propsOfFeatureOnMap || data.properties;
                value = value || props['hrn_pk'];
                if (!!value) {
                  let user = this.User;
                  let orgc = props['org_code'] || props['orgc_fk'];
                  if (!(user.isSuperAdmins || (
                      user.Organization && user.Organization.Code && orgc && 
                      user.Organization.Code.match(new RegExp(orgc,'i')) ||
                      user.NationalId==value))) {
                    value = null;
                  }
                }
              } else if (prop.dataType=='boolean') {
                // convert true/false to 1/0 otherwise null
                // this is required for v-radio-group control 
                // that does not support true/false as value
                value = (value===null || value===undefined) ? null : 
                        !!value ? 1 : 0;
              } else if (value && (prop.dataType=='date' || prop.ctrlType=='date')) {
                value = parseValue(value, 'date');
              }
              if (prop.ctrlType=='select') {
                if (prop.loadOptions && !(prop.options && prop.options.length>0)) {
                  prop.loadOptions(this.User, value);
                }
                if (value && prop.onOptionChange) {
                  callOnOptionChanges.push(prop);
                }
              } else if (prop.ctrlType=='property') {
                if (prop.loadOptions) {
                  prop.loadOptions(this.User, data.properties['gid'], this.cropSuitability);
                } else if (prop.setProperty) {
                  prop.setProperty(crop, value);
                  value = prop.value;
                }
                //prop.originalValue will be set in prop.setProperty()
                originalValue = prop.originalValue;
              } else if (prop.loadOptions) {
                prop.loadOptions(this.User, data.properties['gid']);
              } else if (prop.setProperty) {
                prop.setProperty(crop, value);
              }

              if (value && prop.autoSearch) {
                autoSearches.push(prop);
              }
              if (featureOnMap && prop.canEdit) {
                prop.featureOnMap = featureOnMap;
              }
              return Object.assign(prop, {
                itemIndex: itemIndex,
                propertyIndex: propIndex,
                user: this.User,
                value: value,
                originalValue: originalValue
              });
            })
          };
        })
      };
      callOnOptionChanges.forEach((prop) => {
        try {
          let properties = info.items[prop.itemIndex].properties;
          prop.onOptionChange(properties);
        } catch (error) {}
      });
      autoSearches.forEach((prop) => {
        try {
          let properties = info.items[prop.itemIndex].properties;
          prop.autoSearch(this.User, properties);
        } catch (error) {
        }
      });
    } else {
      let props: IInfoProperty[] = [];
      for (p in data.properties) {
        props.push({
          name: p,
          alias: p.toUpperCase(),
          value: data.properties[p]
        });
      }
      info = {
        title: title.capitalize(),
        //feature: data.featureOnMap,
        items: [{
          properties: props
        }]
      }
    }
    info.canEdit = this.ICanEdit && !!title.match(/^farmland/i);
    if (this.showMapInfoTab>=info.items.length) {
      this.showMapInfoTab = 0;
    }
    return info;
  }

  onMapInfoSelectChange(prop, properties) {
    // IMPORTANT use this as an intermedia to call prop.onOptionChange
    // don't call prop.onOptionChange directly, otherwise it alerts that 
    // onOptionChange is not defined
    if (prop.onOptionChange) {
      prop.onOptionChange(properties);
    }
  }

  onMapInfoDateChange(prop, properties) {
    if (prop.onChange) {
      prop.onChange(properties);
    }
  }

  async onMapInfoAutoSearch(prop, properties) {
    try {
      if (prop.autoSearch) {
        await prop.autoSearch(this.User, properties);
      }
    } catch (error) {
      this.alertError(error.message || 'Error from onMapInfoAutoSearch()');
    }
  }
  
  getMapInfoPhotoUrl(prop) : string {
    //let test = 'https://picsum.photos/500/300?image=15';
    let noImage = this.appUrl +'/static/images/ppix_enabled.png?APIID=th.co.softoo.rest';
    if (!prop.value) {
      return noImage;
    } else if (prop.value=='loading') {
      return undefined;
    } else if ((prop.value+'').match(/^data:image\/[a-z]+;base64,/i)) {
      let blob = base64toBlob(prop.value);
      let url = URL ? URL.createObjectURL(blob) : window['webkitURL'].createObjectURL(blob);
      return url;
    } else if ((prop.value+'').match(/^blob:/i)) {
      return prop.value;
    } else if (prop.value instanceof Blob) {
      // no good, the UI will flick
      return (URL) ? URL.createObjectURL(prop.value) : 
                     window['webkitURL'].createObjectURL(prop.value);
    } else if (prop.photoUrl) {
      return this.appUrl + prop.photoUrl() + '?APIID=th.co.softoo.rest&width=128&height=128';
    }
    return noImage;
  }

  selectMapInfoFarmerPhotoFile(prop:IInfoProperty) {
    if (this.$refs.MapInfoFarmerPhoto) {
      this.MapInfoPhotoProperty = prop;
      (<HTMLElement>this.$refs.MapInfoFarmerPhoto).click();
    } else {
      this.MapInfoPhotoProperty = null;
    }
  };

  resetMapInfoFarmerPhotoInput = function() {
    try {
      if (this.$refs.MapInfoFarmerPhoto) {
        this.$refs.MapInfoFarmerPhoto.value = '';
        this.$refs.MapInfoFarmerPhoto.type = '';
        this.$refs.MapInfoFarmerPhoto.type = 'file';
      }
    } catch(e) {}
  }

  onMapInfoFarmerPhotoChange(event) {
    if (this.MapInfoPhotoProperty) {
      this.MapInfoPhotoProperty.value ='loading';
      let file = event.target.files[0];
      if (file) { //file is not defined when cancel
        //does not make it show faster
        //this.MapInfoPhotoProperty.value = URL ? URL.createObjectURL(file) : 
        //                                  window['webkitURL'].createObjectURL(file);
        // follwoing is to resize the image
        let fileReader = new FileReader();
        fileReader.onload = this.setMapInfoFarmerPhoto;
        fileReader.readAsArrayBuffer(file);
      }
    }
  }

  Jimp;
  MapInfoPhotoProperty:IInfoProperty;
  async setMapInfoFarmerPhoto(event) {
    try {
      if (!this.Jimp) {
        this.Jimp = require('jimp');
      }
      let arrayBuffer = event.target['result'];
      let buffer = Buffer.from(arrayBuffer);
      let photo = await this.Jimp.read(buffer);
      let w = photo.bitmap.width;
      let h = photo.bitmap.height;
      if (w>h) {
        photo = photo.crop((w-h)/2,0,h,h);
      } else if (w<h) {
        photo = photo.crop(0,(h-w)/2,w,w);
      }
      photo.resize(128,128);
      buffer = await photo.getBufferAsync(this.Jimp.MIME_PNG);
      // buffer to Uint8Array
      //let a = new Uint8Array(buffer.length);
      //for (let i=0; i<buffer.length; i++) a[i] = buffer[i];
      let blob = new Blob([new Uint8Array(buffer)],{type:'image/png'});
      //let base64 = await photo.getBase64Async(this.Jimp.MIME_PNG);
      //let blob = base64toBlob(base64, this.Jimp.MIME_PNG);
      //this.MapInfoPhotoProperty.value = blob; //no good, the UI will flick
      this.MapInfoPhotoProperty.value = (URL) ? URL.createObjectURL(blob) : 
                                        window['webkitURL'].createObjectURL(blob);
    } catch (error) {
      this.MapInfoPhotoProperty.value = this.MapInfoPhotoProperty.originalValue;
      this.alertError(error.message || 'Error from setMapInfoFarmerPhoto()');
    }
  }

  async showFeatureInfo(info:IFeatureInfo) {
    this.featureInfo = info;
    try {
      this.featureInfo.fetching = true;
      let feature = info.feature;
      let ft, params:any={}, url = 'gis/';
      let data:IGeoJSON;

      if (feature && feature['NATIVE_SOURCE'].NATIVE_LAYERS[0].SOFTOO_SOURCE) {
        ft = feature['NATIVE_SOURCE'].NATIVE_LAYERS[0].SOFTOO_SOURCE.featureType;
        switch (ft) {
        case 'gisagro:farmland_edit':
          if (!feature.getId()) {
            // this is a newly added feature from editing tool
            data = <IGeoJSON> this.$map.FeatureToGeoJSON(feature);
            data.featureClass = 'farmland'; // IMPORTANT: featureClass is used in buildMapInfo()
            data.featureOnMap = feature;
          } else {
            //url += 'farmland';
            let gid = feature.get('gid');
            if (!gid) {
              gid = (feature.getId()+'').split('.')[1];
            }
            //params.gid = gid;
            url += 'farmland/' + gid;
          }
          break;
        }
      } else {
        if (feature) {
          this.$map.clearLayer('SelectedFeatureLayer');
          feature = null;
        }
        let d = this.$map.getMetersPerPixel() * 5;
        url += 'features/' + info.location.wgs84[0] + ',' + info.location.wgs84[1] + ',' + d;
      }
      if (!data) {
        params.uid = this.User.HalloId || 0;
        data = <IGeoJSON> await this.User.requestResource(url,'GET', params);
        if (data.features && data.type=='FeatureCollection') {
          let d, gData, fData;
          if (this.User.isSuperAdmins) {
            data = data.features[0];
          } else if (!this.User.isOfficials && this.User.NationalId) {
            for (d=0; d<data.features.length; d++) {
              if (this.User.NationalId==data.features[d].properties.ssn_pk) {
                fData = data.features[d];
                break;
              }
            }
            data = fData || data.features[0];
          } else if (this.User.isOfficials && 
            this.User.Organization && this.User.Organization.Code) {
            for (d=0; d<data.features.length; d++) {
              if (this.User.Organization.Code==data.features[d].properties.orgc_fk) {
                fData = data.features[d];
                break;
              } else if (this.User.Organization.Code==data.features[d].properties.org_code) {
                gData = data.features[d];
                //no break;
              }
            }
            data = fData || gData || data.features[0];
          } else {
            data = data.features[0];
          }
        }
        if (feature) {
          data.featureOnMap = feature;
        } else {
          feature = this.$map.GeoJSONToFeatures(data, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857'
          })[0];
        }
      }
      if (this.$map.map.Action.name=='linkData' && data.featureClass=='farmland') {
        this.doLinkData(data, feature);
      } else {
        this.mapInfo = this.buildMapInfo(data);
        this.mapInfo.feature = this.mapInfo.feature || feature;
        this.toc = 'MAP_INFO';
        this.showDrawerLeft = true;
        if (!feature['NATIVE_SOURCE']) {
          setTimeout(() => {
            this.$map.addFeaturesToLayer([feature], "SelectedFeatureLayer", {
              zoomTo: false
            });
          },250);
        }
      }
      this.featureInfo.fetching = false;
    } catch (error) {
      this.featureInfo.fetching = false;
      if (error.id=='not_found' || error.id=='no_content') {
        this.mapInfo = {
          title: 'noData',
          items: []
        }
      } else {
        this.alertError(error.message || 'Error from showFeatureInfo()');
      }
    }
  };

  // methods
  setMapAction(action: IMapAction) {
    if (!action || !action.name || action.name==this.activeAction) {
      this.activeAction = null;
      this.showMeasurer = false;
      this.$map.setMapAction(null);
    } else if (action.name.match(/undo|redo/)) {
      this.$map.setMapAction(action.name);
    } else if (action.name.match(/save/)) {
      this.saveMap();
    } else if (action.name=='changeBasemap') {
      this.activeBaseMap = action.params.id;
    } else if (action.name=='printMap') {
      this.showMapForPrint("land");
    } else if (action.name=='uploadGpx') {
      // replaced with "uploadLand" below
    } else if (action.name.match(/zoom|pan|zoomToExtent/)) {
      // these actions will not be remained
      if (action.params && action.params.info) {
        let info = action.params.info;
        this.$map.addFeaturesToLayer([info.feature], 
          this.srhDataSource.match(/DOL|PLACE/) ? 'SearchFeatureLayer' : 'SelectedFeatureLayer', {
          resetMapExtent: false
        });
        this.$map.showInfoPopup(info.title, info.info, info.popup);
      } else {
        this.$map.changeMapView(action.name, action.params);
      }
    } else if (action.name=='showLocator') {
      this.showSpeedTester = false;
      this.showUploader = false;
      this.showLocator = true;
      if (!this.showLocatorAt) {
        this.showLocatorAt = 'top-center';
      }
    } else if (action.name=='showSpeedTester') {
      this.showLocator = false;
      this.showUploader = false;
      this.showSpeedTester = true;
      if (!this.showSpeedTesterAt) {
        this.showSpeedTesterAt = 'bottom-center';
      }
    } else if (action.name=='uploadLand') {
      this.showLocator = false;
      this.showSpeedTester = false;
      this.showDrawerRight = false;
      this.showUploader = true;
      if (!this.showUploaderAt) {
        this.showUploaderAt = 'center';
      }
    } else {
      // these should be mappint tools.
      // their actions will remain till it is changed
      if (action.name==this.activeAction) {
        action.name = null; // toggle off
      }
      this.activeAction = action.name;
      if (action.name == 'measure') {
        action.params.target = this.$refs.measureResult;
        //this.showMeasurer = true;
        this.showMeasurer = !!this.activeAction;
        if (!this.showMeasurerAt) {
          this.showMeasurerAt = 'bottom-left';
        }
        setTimeout(() => {
          this.$map.setMapAction(action.name, action.params || {});
        }, 100); // give at least 50ms for UI to be ready
      } else {
        action.params = action.params || {};
        /*this is for RAOT requirements*/
        if (action.name=='splitPolygon') {
          // a callback function for selecting targets to be splitted
          action.params = {
            selectSplitTargets: selectSplitTargets,
            afterSplitted: afterSplitted
          };
        } else if (action.name=='cutPolygonHole') {
          action.params = {
            afterCut: afterCut
          };
        } else if (action.name.match(/moveFeature|indian75ToWgs84/)) {
          action.params = {
            afterMoved: afterMoved
          };
        } else if (action.name=='modifyFeature') {
          action.params = {
            afterModified: afterModified
          };
        } else if (action.name.match(/deleteFeature|deleteFeatures/)) {
          let $this = this;
          action.params = {
            afterDeleted: afterDeleted,
            disallowToDelete: (feature:Feature) => {
              if (!$this.User.ResponsibleAreaCode || 
                  feature.get('STATE')=='Insert') {
                return false;
              }
              let code:number = parseInt($this.User.ResponsibleAreaCode);
              let n = (code+'').length;
              let aag = n==2 ? 'aag3_fk' : n==4 ? 'aag4_fk' : n==6? 'aag5_fk' : null;
              return !(!!aag && (code==(feature.get(aag))));
              //return !!feature.get('fssn_fk');
            }
          };
        }
        this.showMeasurer = false;
        this.$map.setMapAction(action.name, action.params || {});
      }
    }
  };

  //showNoDeleteFeature() {
  //  this.showDialog('attention','sNotAllowedToDeleteLandWithFarmerSSN');
  //}

  featuresToSave: IFeatureToSave;
  farmlandSchema;
  saveErrors:any[];
  async saveMap() {
    try {
      this.saveErrors = [];
      let saves:IFeatureToSaveByIntersects = await this.$map.getFeaturesToSaveByIntersect(this.checkLandIntersects);
      
      if (!(saves && (saves.intersected || saves.notIntersected))) {
        this.featuresToSave = null;
      } else {
        let total = saves.intersected ? saves.intersected.total : 0;
        total += (saves.notIntersected ? saves.notIntersected.total : 0);
        let msg = '';
        let action;
        if (saves.intersected) {
          let forests:any = [];
          for (action in saves.intersected.polygons) { //by design, saves.intersected contains only polygons
            saves.intersected.polygons[action].forEach((f) => {
              f.get('in_conserved').split(',').map((n) => {
                let name = (n+'').trim();
                if (forests.indexOf(name)==-1) {
                  forests.push(name);
                }
              });
            });
          }
          let forestName = '';
          forests.forEach((name, index) => {
            forestName += (index==0 ? '' : (index==forests.length-1) ? ' และ ' : ', ') + name;
          });
          if (forestName.indexOf('เขต')!==0) {
            forestName = 'เขต' + forestName;
          }
          forests = forests.join(', ');
          if (saves.intersected.total == total) {
            msg = 'แปลงที่จะบันทึกซ้อนทับกับ' + forestName + ' คุณต้องการบันทึกต่อไหม?';
          } else {
            msg = 'กำลังจะบันทึกข้อมูลจำนวน ' + total + ' แปลง แต่มี ' + saves.intersected.total + ' แปลง';
            msg += 'ซ้อนทับกับ' + forestName + ' คุณต้องการบันทึกแปลงเหล่านี้ด้วยไหม?';
          }
          this.$store.commit('notifyChange', {
            Dialog: {
              Type: 'alert',
              Title: 'แปลงซ้อนทับเขตป่า',
              Message: msg,
              OkText: 'yes',
              CancelText: 'no',
              show: true,
              OnClose: (answer) => {
                let save:IFeatureToSave = saves.intersected;
                if (answer=='ok') {
                  save = saves.intersected;
                } else {
                  save = {
                    total: 0
                  }
                }
                ['points','lines','polygons'].forEach((type) => {
                  if (saves.notIntersected && saves.notIntersected[type]) {
                    save[type] = save[type] || {};
                    for (action in saves.notIntersected[type]) {
                      save[type][action] = save[type][action] || [];
                      save[type][action] = save[type][action].concat(saves.notIntersected[type][action]);
                    }
                  }
                });
                save.total += (saves.notIntersected ? saves.notIntersected.total : 0);
                if (save.points || save.lines || save.polygons) {
                  this.saveMapYes(save);
                }
                return true; //save.total==0;
              }
            }
          });
        } else if (saves.notIntersected && 
          (saves.notIntersected.points || saves.notIntersected.lines || saves.notIntersected.polygons)) {
          this.saveMapYes(saves.notIntersected);
        }
      }
    } catch (error) {
      this.alertError(error.message || 'Error from saveMap()');
    }
  }

  async saveMapYes(save:IFeatureToSave) {
    try {
      let i, layer, layers = [{
        type: 'points',
        name: 'farmland_point'
      },{
        type: 'lines',
        name: 'farmland_line'
      },{
        type: 'polygons',
        name: 'farmland'
      }];
      let j, action, actions = ['delete','insert','update']; // do 'delete' the first
      if (save.total>0) {
        this.showWait('saveDataToDatabase');
      }
      this.featuresToSave = save;
      this.farmlandSchema = this.farmlandSchema || require("../../public/static/js/schemas").farmland;
      for (i=0; i<layers.length; i++) {
        layer = layers[i];
        if (save[layer.type]) {
          for (j=0; j<actions.length; j++) {
            action = actions[j];
            let features = save[layer.type][action];
            let k, feature;
            if (features) {
              for (k=0; k<features.length; k++) {
                feature = features[k];
                let method;
                if (action=='insert') {
                  method = 'POST';
                } else if (action=='update') {
                  method = 'PUT';
                } else {
                  method = 'DELETE';
                }
                await this.doSaveMap(layer.name, method, feature);
                this.featuresToSave.total--;
              };
            }
          };
        }
      };
      if (this.featuresToSave.total==0) {
        this.onSaveMapCompleted();
      }
    } catch (error) {
      throw(error);
    }
  }

  onSaveMapCompleted() {
    if (!(this.saveErrors && this.saveErrors.length>0)) {
      this.$map.updateFeaturesToSave(this.featuresToSave);
      setTimeout(() => {
        this.closeDialog('close');
      }, 1000);
    }
  }
  
  async checkLandIntersects(feature:Feature, geomType:"points" | "lines" | "polygons") : Promise<any> {
    try {
      let checks;
      if (geomType=='polygons') {
        let wkt = this.$map.FeatureToWKT(feature, {
          dataProjection:'EPSG:4326',
          featureProjection:'EPSG:3857'
        });
        checks = await this.User.requestResource('gis/intersects/forests', 'POST', {
          wkt: this.$map.FeatureToWKT(feature, {
            dataProjection:'EPSG:4326',
            featureProjection:'EPSG:3857'
          }),
          srid: 4326
        });
      } else {
        checks = {
          intersected: false
        };
      }
      return checks;
    } catch (error) {
      throw(error);
    }
  }

  /*async checkIntersectWithForest(features:IFeatureToSave) : Promise<IFeatureToSaveByIntersects> {
    try {
      let layers = [{
        type: 'points',
        name: 'farmland_point'
      },{
        type: 'lines',
        name: 'farmland_line'
      },{
        type: 'polygons',
        name: 'farmland'
      }];
      let polygons: IEditingFeature
      let saves = features.map((f) => {
        return this.User.requestResource('gis/intersects/forests', 'POST', {
          wkt: this.$map.FeatureToWKT(f, {
            dataProjection:'EPSG:4326',
            featureProjection:'EPSG:3857'
          }),
          srid: 4326
        })
      });
      let data = await Promise.all(saves);
      let checks:IFeatureToSaveByIntersects = {};
      data.forEach((d, index) => {
        if (d.intersected) {
          checks.intersected = checks.intersected || [];
          checks.intersected.push(features[index]);
        } else {
          checks.notIntersected = checks.notIntersected || [];
          checks.notIntersected.push(features[index]);
        }
      });
      return checks;
    } catch (error) {
      throw(error);
    }
  }*/

  async doSaveMap(layerName:string, method:"POST" | "PUT" | "DELETE", feature:Feature) {
    try {
      await this.doSaveFeature(layerName,method,feature);
    } catch (error) {
      let e = error
      this.saveErrors.push(error);
      let errMsg = this.Dialog.Message ? this.Dialog.Message + ' ' : '';
      if (error.message) {
        errMsg += error.message;
      } else {
        errMsg += 'ระบบขัดข้อง';
      }
      this.showWait('saveDataToDatabase', errMsg);
    }
  }
  
  async doSaveFeature(layerName:string, method:"POST" | "PUT" | "DELETE", feature:Feature) {
    try {
      let fid = feature.getId()+'';
      let url:string;
      let land:any = {};
      let others: any = {};
      if (method=='DELETE') {
        url = 'mis/' + layerName;
        land = {
          gid: parseInt(fid.split('.')[1]),
          user_fk: this.User.Code
        }
      } else {
        url = 'gis/' + layerName;
        let schema = this.farmlandSchema || require("../../public/static/js/schemas").farmland;
        let gJSON = this.$map.FeatureToGeoJSON(feature, {
          dataProjection:'EPSG:4326',
          featureProjection:'EPSG:3857'
        });
        // exlucding featureOnMap and others
        let p, v, props:any = {};
        land = {
          type: gJSON.type,
          geometry: gJSON.geometry,
          properties: gJSON.properties
        };
        if (method=='PUT') {
          props.gid = land.properties['gid'] || parseInt(fid.split('.')[1]);
        }

        for (p in land.properties) {
          if (schema.hasOwnProperty(p)) {
            v = parseValue(land.properties[p], schema[p].dataType);
            for (let source in schema[p].source) {
              p = schema[p].source[source];
              if (source=='farmland') {
                props[p] = v;
              } else {
                others[source] = others[source] || {};
                others[source][p] = v || others[source][p];
              }
            }
          }
        }
        others.farmer = others.farmer || others.person;
        props.user_fk = this.User.Code;
        props.org_code = props.org_code || this.User.Organization.Code;
        if (others.address && others.address.hrn_pk) {
          others.address = await this.User.requestResource('mis/address','PUT', others.address);
          if (others.farmer) {
            others.farmer.hrn_fk = others.address.hrn_pk;
          }
        }
        if (others.farmer && others.farmer.ssn_pk) {
          others.farmer.user_fk = this.User.Code;
          others.farmer = await this.User.requestResource('mis/farmer','PUT', others.farmer);
          props.fssn_fk = others.farmer[others.farmer.keyname || 'ssn_pk'];
          if (others.farming) {
            others.farming.farmer_ssn = props.fssn_fk;
          }
        }
        land.properties = props;
      }
      land = await this.User.requestResource('gis/' + layerName, method, land);
      if (others.farming) { // save to farming
        others.farming.gid_fk = land[land.keyname || 'gid'];
        others.farming.orgc_fk = others.farming.orgc_fk || this.User.Organization.Code;
        others.farming.user_fk = this.User.Code;
        method = others.farming.fid ? 'PUT' : 'POST';
        others.farming = await this.User.requestResource('mis/farming', method, others.farming);
        land[others.farming['keyname']] = others.farming[others.farming['keyname']];
      }
      feature.set('newProps',land, true); // used to update feature properties in this.$map.updateSaveFeature()
      return land;
    } catch (error) {
      throw error;
    }
  }

  getChangedAttrs(info:IInfoSchema) : {[key:string] : IInfoProperty} {
    let source:string, changes:any = {};
    let prop:IInfoProperty;
    let i:number;
    let hasChanged:boolean;
    let required:{[key:string]:string[]} = {};
    let req;
    info.items.forEach((item) => {
      for (let p=0; p<item.properties.length; p++) {
        prop = item.properties[p];
        if (prop.mandatory && !prop.value) {
          req = required[prop.itemIndex];
          if (!req) {
            required[prop.itemIndex] = [];
            req = required[prop.itemIndex]
          }
          if (req.indexOf(prop.alias)==-1) {
            req.push(prop.alias);
          }
        }
        hasChanged = false;
        //if (prop.ctrlType!='photo' && prop.source) {
        if (prop.source) {
          if (prop.ctrlType=='property') {
            if (prop.getValue) {
              hasChanged = prop.getValue().hasChanged;
            } else {
              hasChanged = false;
            }
          } else {
            hasChanged = (prop.value!=prop.originalValue) && 
                        !(prop.value==='' && prop.originalValue===null);
          }
        }
        if (prop.isKey || hasChanged) {
          if (prop.dataType!='boolean' && prop.ctrlType!='property') {
            prop.value = parseValue(prop.value, prop.dataType);
          }
          if (isString(prop.source)) {
            source = <string> prop.source;
            changes[source] = changes[source] || {};
            changes[source][prop.name] = prop;
          } else if (isArray(prop.source)) {
            for (i=0; i<(<string[]>prop.source).length; i++) {
              source = prop.source[i];
              changes[source] = changes[source] || {};
              changes[source][prop.name] = prop;
            }
          } else if (isObject(prop.source)) {
            // foreign key fields are also linked to their primary key field here
            for (source in <{[key:string]:string}> prop.source) {
              changes[source] = changes[source] || {};
              changes[source][prop.source[source]] = prop;
            }
          }
        }
      }
    });

    //final check
    let realChanges = {};
    let p,rp;
    //let exclude:string[] = [];
    for (source in changes) {
      for (p in changes[source]) {
        prop = changes[source][p];
        if ((prop.ctrlType=='property') || (prop.value!=prop.originalValue)) {
          realChanges[source] = changes[source];
          for (p in realChanges[source]) {
            prop = realChanges[source][p]; // prop here is the primary source
            if (prop.isKey) {
              //primary key field is required if any other field 
              //of the primary source has changed
              let isPrimaryKey = false;
              for (i=0; i<info.saveOrder.length && !isPrimaryKey; i++) {
                isPrimaryKey = info.saveOrder[i].name==source && 
                               info.saveOrder[i].primary==prop.name;
              }
              if (isPrimaryKey && (prop.ctrlType!=='hidden') && 
                !(prop.value && prop.validate && prop.validate())) { 
                req = required[prop.itemIndex];
                if (!req) {
                  required[prop.itemIndex] = [];
                  req = required[prop.itemIndex]
                }
                if (req.indexOf(prop.alias)==-1) {
                  req.push(prop.alias);
                }
              }
            }
          }
          break;
        }
      }
    }

    /*remove those such as farmer and address that required ssn_pk and hrn_pk, respectively
    exclude.forEach((source) => {
      if (realChanges[source]) {
        delete realChanges[source];
      }
    });
    */
    let n = Object.keys(required).length;
    if (n>0) {
      let err = '';
      for (p in required) {
        err += '<li><label>ในแถบ' + info.items[p].group + '</label>';
        err += '<div>' + required[p].join(', ') + '</div></li>';
      }
      err = '<div>ต้องระบุค่าดังต่อไปนี้ให้ถูกต้อง:</div>' + 
            '<ul style="margin-left:38px">' + err + '</ul>';
      this.showDialog('saveDataToDatabase', err, 'alert-html');
      return null;
    }
    return realChanges;
  }

  async saveFeatureAttrs(info:IInfoSchema, asNew?:boolean, hasChecked?:boolean) {
    try {
      let i, p;
      let resp;
      let changes = this.getChangedAttrs(info);
      if (changes) {
        let source;
        //save geometry
        let areaModifiedMode = null;
        let linkToNewLand:boolean = info.feature && !info.feature.get('fssn_fk');
        if (info.feature && info.feature['NATIVE_SOURCE']) {
          source = changes['farmland'];
          if (source) {
            for (p in source) {
              info.feature.set(p,parseValue(source[p].value, source[p].dataType));
            }
          }
          if (info.feature.get('STATE')) {
            let method:"POST" | "PUT" = info.feature.get('STATE').match(/Insert/i) ? 'POST' : 'PUT';
            if (!hasChecked) {
              let check = await this.checkLandIntersects(info.feature,'polygons');
              if (check && !!check.intersected) {
                let forests:any = [];
                let forestName = check.name;
                if (forestName.indexOf('เขต')!==0) {
                  forestName = 'เขต' + forestName;
                }
                let msg = 'แปลงนี้ซ้อนทับกับ' + forestName + ' คุณต้องการบันทึกต่อไหม?';
                this.$store.commit('notifyChange', {
                  Dialog: {
                    Type: 'alert',
                    Title: 'แปลงซ้อนทับเขตป่า',
                    Message: msg,
                    OkText: 'yes',
                    CancelText: 'no',
                    show: true,
                    OnClose: (answer) => {
                      if (answer=='ok') {
                        this.saveFeatureAttrs(info, asNew, true);
                      }
                    }
                  }
                });
                return;
              }
            }
            areaModifiedMode = info.feature.get('AreaModifiedMode'); //set in farmland.ts
            if (info.feature.get('STATE').match(/Insert/i)) {
              linkToNewLand = true;
            } else {
              linkToNewLand = !info.feature.get('fssn_fk');
            }
            this.showWait('saveDataToDatabase');
            resp = await this.doSaveFeature('farmland', method, info.feature);
            this.$map.updateSavedFeature(info.feature);
            if (source) {
              if (resp.hasOwnProperty('gid') && 
                (!source['gid'].value || (source['gid'].value==resp['gid']))) {
                changes['farmland']['gid'].value = resp['gid'];
              } else {
                throw {
                  id: 'internal_sever_error',
                  status: 500,
                  message: 'Saving feature does not return ' + (resp['gid'] ? 'the same gid' : ' a gid')
                };
              }
            }
            source = changes['farming'];
            if (source && resp.hasOwnProperty('fid')) {
              asNew = asNew && !!source['fid'].value;
              source['fid'].value = resp['fid'];
              if (resp.hasOwnProperty('gid')) {
                source['gid_fk'].value = resp['gid'];
              }
            }
          }
        }
        this.showWait('saveDataToDatabase');
        for (i=0; i<info.saveOrder.length; i++) {
          let saveOrder = info.saveOrder[i];
          source = saveOrder.name;
          if (source=='farming' && changes[source]) {
            changes[source]['status_em'] = {
              name: 'status_em',
              dataType: 'integer',
              value: linkToNewLand ? 10 : 
                    areaModifiedMode=='enlarged' ? 21 :
                    areaModifiedMode=='reduced' ? 22 : 20
            };
          }
          let props = changes[source];
          let key = saveOrder.primary;
          let attrs:{[key:string] : any} = {};
          let blob:Blob; // will upload using post formdata
          if (props) {
            if (asNew && source=='farming') {
              props[key].value = null;
            }
            blob = null;
            for (p in props) {
              if (props[p].ctrlType=='property') {
                let json = props[p].getValue();
                if (json.hasChanged) {
                  attrs[p] = json.value;
                }
              } else if (props[p].ctrlType!='property' && props[p].value && 
                (props[p].value+'').match(/^blob:/i)) {
                blob = await fetch(props[p].value,{headers: {'Content-Type':'image/png'}})
                      .then((response)=> {
                        return response.blob();
                      });
              } else if (props[p].dataType=='boolean') {
                attrs[p] = (props[p].value===null || props[p].value===undefined) ? null :
                          !!props[p].value;
                          // change 1/0 back to true/false otherwise null
              } else {
                attrs[p] = props[p].value;
              }
            }
            attrs.user_fk = this.User.Code;
            if (source=='farmland') {
              attrs.org_code = this.User.Organization.Code;
            } else if (source=='farming') {
              attrs.orgc_fk = this.User.Organization.Code;
            }
            let method;
            if (blob) {
              // must convert blob to File and name it as
              // 'blob.{fieldName}.png|jpg|gif'
              resp = await this.User.uploadFileUsingFetch('image/avatar/' + source + '/' +attrs[key], {
                file: new File([blob],'blob.photo.png',{type:'image/png'}),
                fieldName: 'photo',
                details: attrs
              });
            } else {
              method = !attrs[key] ? 'POST' : 'PUT';
              resp = await this.User.requestResource('mis/' + source, method, attrs);
            }
            // reset values
            for (p in props) {
              if (props[p].ctrlType=='property') {
                if (attrs[p]) {
                  props[p].originalValue = attrs[p];
                }
              } else {
                if (props[p].dataType=='date') {
                  props[p].value = new Date(props[p].value);
                } else {
                  props[p].originalValue = props[p].value;
                }
              }
            }
            changes[source][key].value = resp[resp.keyname];
            changes[source][key].originalValue = resp[resp.keyname];
            if (saveOrder.foreigns) {
              for (source in saveOrder.foreigns) {
                if (changes[source]) {
                  key = saveOrder.foreigns[source];
                  changes[source][key].value = resp[resp.keyname];
                }
              }
            }
          }
        };
        source = changes['farmland'];
        if (info.feature && source) {
          info.feature.set('fssn_fk',source.fssn_fk.value);
        }
        setTimeout(() => {
          this.closeDialog('close');
        }, 2000);
      }
    } catch (error) {
      this.showWait('saveDataToDatabase', error.message || 'Error from saveFeatureAttrs()');
    }
  }

  showUserProfile() {
    this.doMenuAction({
      name: 'show_profile',
      title: this.User.FullName
    });
    this.RightTocData = this.User;
    //this.DrawerHelperSubTitle = 'profile';
  };

  showOnlineUsers() {
    this.doMenuAction({
      name: 'show_online_users',
      title: this.User.FullName
    });
    //this.DrawerHelperSubTitle = 'onlineUsers';
  };
  
  LeftTocData:Object = {
    $map: this.$map,
    filter: this.mapFilter
  }; 

  callFromLeftToc(cmd) {
    if (cmd.name=='show_farmland_layer') {
      //emitted from ./toc/search.base.ts
      let farmland = this.mapLayers[0];
      if (!farmland.visible) {
        farmland.checked = farmland.visible = true;
        farmland.mapSources.forEach((ms) => {
          ms.visible = true;
          if (ms.nativeLayer) {
            ms.nativeLayer.setVisible(ms.visible);
          }
        });
        farmland.legend.forEach((item) => {
          if (item.mapSources && item.type) {
            item.checked = true;
            item.visible = !!item.checked;
          }
        }, this);
        this.doMapLayerAction({
          item: farmland,
          action: {
            action: 'changeChecked'
          }
        });
      }
    } else if (cmd.name=='change_map_filter') {
      for (let f in cmd.data) {
        if (f=='Area1' || f=='Area2') {
          for (let a in cmd.data[f]) {
            this.mapFilter[f][a] = cmd.data[f][a];
          }
        } else {
          this.mapFilter[f] = cmd.data[f];
        }
      }
      if (!!this.RightTocData && !!this.RightTocData.filter) {
        //this.RightTocData = this.RightTocData || {};
        //this.RightTocData.filter = cmd.data;
        this.RightTocData.refresher = (new Date()).getTime();
      }
    }
  }
  
  RightTocData: any = null;
  changeRightToc(data) {
    this.doMenuAction(data.menu);
    this.RightTocData = data.data;
  }

  closeRightToc() {
    this.showDrawerLeft = this.showDrawerLeftLast;
    this.showDrawerRight2 = !this.showDrawerRight2;
  }
  
  closeRightSideDrawer() {
    this.showDrawerLeftLast = this.showDrawerLeft;
    this.showDrawerLeft = false;
    this.showDrawerRight = false;
  }

  doMenuAction(menu) {
    /*if (!this.ImAdmin || menu.name=='show_profile') {
      this.DrawerHelperTools = END_USER_TOOLS;
    } else {
      if (menu.name.match(/users$/)) {
        this.DrawerHelperTools = ADMIN_USERS_TOOLS;
        this.DrawerHelperActions = ADMIN_USERS_ACTIONS;
        this.DrawerHelperEditTools = ADMIN_EDIT_USER_TOOLS;
      } else {
        this.DrawerHelperTools = ADMIN_ORGS_TOOLS;
        this.DrawerHelperActions = ADMIN_ORGS_ACTIONS;
        this.DrawerHelperEditTools = ADMIN_EDIT_ORG_TOOLS;
      }
    }
    this.DrawerHelperTitle = menu.title;
    if (menu.icon) {
      this.DrawerHelperIcon = menu.icon;
      this.DrawerHelperAvatar = null;
    } else {
      this.DrawerHelperIcon = null;
      this.DrawerHelperAvatar = this.User.Avatar;
    }*/
    
    this.showDrawerLeftLast = this.showDrawerLeft;
    this.showDrawerLeft = false;
    this.showDrawerRight = false;
    setTimeout(() => {
      this.showDrawerRight2 = true;
      this.doHelperTool({
        name: menu.name
      });
    }, 0); // give time to close the right most sidedrawer
  };

  doHelperTool(tool: IIconTool) {
    switch (tool.name) {
    // admin organizations
    
    case 'admin_users':
      this.DrawerHelperPage = 'admin_users';
      break;
    case 'admin_online_users':
      // show websocket connected users
      this.DrawerHelperPage = 'admin_users';
      break;
    // admin users
    case 'admin_adduser':
      this.DrawerHelperPage = 'admin_adduser';
      break;
    case 'show_userlogs':
      this.DrawerHelperPage = 'admin_userlogs';
      break;
    // for end users
    case 'show_profile':
      this.DrawerHelperPage = 'user_profile';
      break;
    case 'show_online_users':
      // show websocket connected users
      this.DrawerHelperPage = 'online_users';
      this.RightTocData = this.WebSocket;
      break;
    case 'help':
      this.DrawerHelperPage = 'help';
      this.RightTocData = { src:'/static/docs/GISagro_Land_User_Manual.pdf' };
      break;
    }
  };

  MAX_ROWS_TO_SHOW = 50;
  FileUploaderFileName:string = '';
  FileUploaderAttrs:string[] = ['TYPE'];
  FileUploaderAttrsValues:any[][] = [];
  isReadingFileUploaderFile: boolean = false;
  uploadedLandGeoJson = null;
  openFileUploader() {
    (<HTMLElement>this.$refs.FileUploader).click();
  };

  onFileUploaderChange(event) {
    let file = event.target.files[0];
    if (!file) { //file is not defined when cancel
      return;
    }
    let name = file.name;
    if (!name.match(/\.gpx$|\.zip$/i)) {
      this.showWait('attention','Only is *.gpx or *.zip file supported');
      return;
    }
    this.uploadedLandGeoJson = null;
    this.FileUploaderFileName = null;
    let fileReader = new FileReader();
    this.isReadingFileUploaderFile = true;
    this.FileUploaderAttrs = ['TYPE']; // field name. first column is 'TYPE' for polygon/line/point
    this.FileUploaderAttrsValues = [];
    if (name.match(/\.gpx$/i)) {
      fileReader.onload = this.parseGpxFile;
      fileReader.readAsText(file);
    } else if (name.match(/\.zip$/i)) {
      fileReader.onload = this.parseZipFile;
      fileReader.readAsArrayBuffer(file);
    }
  }

  get HowManyFeatures() : string {
    let hm = '';
    if (this.uploadedLandGeoJson) {
      let n = this.uploadedLandGeoJson.features.length;
      if (n===0) {
        hm = '(' + L('noData') + ')';
      } else {
        hm = '(' + Math.min(n,this.MAX_ROWS_TO_SHOW) + '/' + n + ')';
      }
    }
    return hm;
  }

  async parseGpxFile(event) {
    try {

    } catch (error) {
      this.isReadingFileUploaderFile = false;
      this.showWait('error', error.message || 'Error from parseGpxFile()');
    }
  }

  async parseZipFile(event) {
    try {
      let buffer = event.target['result'];
      //self.isReadingFileUploaderFile = true;
      let gjson = await shp(buffer);
      if (gjson.features && gjson.features.length>0) {
        let nFeatures = gjson.features.length;
        let i, n, p, f = gjson.features[0];
        if (f.properties) { // read column names
          for (p in f.properties) {
            this.FileUploaderAttrs.push(p.toUpperCase());
          }
        } 
        if (this.FileUploaderAttrs.length==1) {
          this.FileUploaderAttrs.push('NO_ATTRIBUTES');
        }
        // read feature attrs
        // read max 50 records just for show for example
        n = Math.min(nFeatures, this.MAX_ROWS_TO_SHOW);
        for (i=0; i<n; i++) {
          f = gjson.features[i];
          let v:any[] = [];
          if (f.geometry.type.match(/Polygon/i)) {
            v.push('polygon');
          } else if (f.geometry.type.match(/Line/i)) {
            v.push('line');
          } else if (f.geometry.type.match(/Point/i)) {
            v.push('point');
          } else {
            v.push('na');
          }
          if (f.properties) {
            for (p in f.properties) {
              v.push(f.properties[p]);
            }
          }
          if (v.length==1) {
            v.push(null);
          }
          this.FileUploaderAttrsValues.push(v);
        }
        this.uploadedLandGeoJson = gjson;
        this.FileUploaderFileName = gjson.fileName + '.zip'; 
        //assign a value to FileUploaderFileName will show up FileUploaderAttrsValues
      } else {
        this.showWait('attention', 'fileHasNoData');
      }
      this.isReadingFileUploaderFile = false;
    } catch (error) {
      this.isReadingFileUploaderFile = false;
      this.showWait('error', error.message || 'Error from parseZipFile()');
    }
  }

  resetFileUploader() {
    this.FileUploaderFileName = null;
    try {
      this.$refs.FileUploader['value'] = '';
      this.$refs.FileUploader['type'] = '';
      this.$refs.FileUploader['type'] = 'file';
    } catch(e) {}
  }

  async acceptFileUpload() {
    try {
      let mapping = require("../../public/static/js/schemas").upload_mapping;
      let crops:any = {
        type_fk_g: {},
        genus_fk_g: {},
        crop_fk_g: {}
      };
      let i, feature;
      for (i=0; i<this.uploadedLandGeoJson.features.length; i++) {
        feature = this.uploadedLandGeoJson.features[i];
        let props:any = {};
        for (let p in feature.properties) {
          let pv = feature.properties[p];
          let to = mapping[p];
          if (to) {
            if (to.name.match(/type_fk_g|genus_fk_g|crop_fk_g/)) {
              if (!crops[to.name][pv]) {
                if (pv) {
                  try {
                    let type = to.name.match(/type_fk/) ? 'type' : 
                               to.name.match(/genus_fk/) ? 'genus' : 'crop';
                    let crop = await this.User.requestResource('mis/cropcode', 'GET', {
                      type: 'crop' + type,
                      name: pv
                    });
                    props[to.name] = crop[0].code;
                    crops[to.name][pv] = crop[0].code;
                  } catch (error) {}
                  props[to.name] = null;
                } else {
                  props[to.name] = null;
                }
              } else {
                props[to.name] = crops[to.name][pv];
              }
            } else {
              props[to.name] = parseValue(pv,to.dataType);
            }
          }
        }
        //props.crop_fk = props.crop_fk || props.genus_fk || props.type_fk;
        feature.properties = props;
      };
      let features = this.$map.GeoJSONToFeatures(this.uploadedLandGeoJson, {
        dataProjection:'EPSG:4326',
        featureProjection:'EPSG:3857'
      });
      let checks:any = features.map((f) => {
        return this.User.requestResource('gis/intersects/forests', 'POST', {
          wkt: this.$map.FeatureToWKT(f, {
            dataProjection:'EPSG:4326',
            featureProjection:'EPSG:3857'
          }),
          srid: 4326
        });
      });

      checks = await Promise.all(checks);
      let intersects:{[key:string] : Feature[]} = {};
      checks.forEach((check, index) => {
        if (check.intersected) {
          features[index].set('in_conserved',check.name);
          intersects.intersected = intersects.intersected || [];
          intersects.intersected.push(features[i]);
        } else {
          features[index].unset('in_conserved');
          intersects.notIntersected = intersects.notIntersected || [];
          intersects.notIntersected.push(features[i]);
        }
      });

      if (intersects.intersected) {
        let msg;
        if (features.length==1) {
          msg = 'แปลงนี้ซ้อนทับเขต' + features[0].get('in_conserved');
          msg += ' จะเพิ่มข้อมูลแปลงนี้ไหม?';
        } else if (intersects.intersected.length==features.length) {
          msg = 'แปลงเหล่าวนี้ซ้อนทับเขตป้า จะเพิ่มข้อมูลไหม?';
        } else {
          msg = 'มีจำนวน ' + intersects.intersected.length + ' แปลงซ้อนทับเขตป่า';
          msg += ' จะเพิ่มข้อมูลเหล่าวนี้ด้วยไหม?'
        }
        this.$store.commit('notifyChange', {
          Dialog: {
            Type: 'alert',
            Title: 'แปลงซ้อนทับเขตป่า',
            Message: msg,
            OkText: 'yes',
            CancelText: 'no',
            show: true,
            OnClose: (answer) => {
              if (answer=='ok') {
                this.addUploadedFeature(features);
              } else if (intersects.notIntersected) {
                this.addUploadedFeature(intersects.notIntersected);
              }
            }
          }
        });
      } else {
        this.addUploadedFeature(features);
      }
    } catch (error) {
      this.alertError(error.message || "Error from acceptUploadFile()");
    }
  };

  addUploadedFeature(features:Feature[]) {
    let unsupported = this.$map.addFeaturesToEditingLayers(features);
    this.resetFileUploader();
    this.showUploader = false;
    this.showUploaderAt = null;
    if (unsupported && unsupported.length>0) {
      this.showWait('attention', 'There are ' + unsupported.length + ' unsupported features');
    }
  }

  closeFileUploader() {
    this.showUploader = false;
    this.FileUploaderFileName = null;
    this.uploadedLandGeoJson = null;
    this.showUploaderAt = null;
    this.resetFileUploader();
  }

  // toc for search or land info
  toggleToc(toc) {
    let ml = this.mapLayers;
    if (this.toc==toc) {
      this.showDrawerLeft = false;
      this.toc = null;
    } else {
      this.showDrawerLeft = true;
      this.toc = toc;
      if (!!this.toc.match(/SEARCH|DOWNLOAD/)) {
        this.LeftTocData = {
          $map: this.$map,
          filter: this.mapFilter
        };
      }
    }
  };
  
  closeDrawerRight2() {
    this.showDrawerRight2 = false;
    this.showDrawerLeft = !!this.toc;
    this.$map.panInfoPopupIntoView();
  }

  doSearchInHelper() {
    this.isSearching = true;
    let self = this;
    setTimeout(() => {
      self.isSearching = false;
    }, 1500);
  };

  get UploadTemplateUrl() : string {
    return this.appUrl + '/downloads/gisagro_upload_template.zip?APIID=th.co.softoo.rest';
  }

  showUserLogin() {
    let this$ = this;
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: 'login',
        Title: 'login',
        Message: null,
        OkText: 'login',
        CancelText: 'cancel',
        show: true,
        OnClose: (result) => {
          if (result=='ok') {
            this$.createFarmlandLayer();
          } else {
            //this.closeToHome();
            this.goToHome();
            window.close();
          }
        }
      }
    });
  }

  userData: {[key:string] : any} = null;
  LinkedLands: {[key:string] :any};
  ldShowUserData:boolean = false;
  ldShowLinkedLands:boolean = false;

  async showLandToLink(land:{[key:string] : any}) {
    try {
      let data = <IGeoJSON> await this.User.requestResource('gis/farmland','GET', {
        gid: land.gid
      });
      if (data.features) {
        let itIs, i;
        for (i=0; i<data.features.length; i++) {
          if (land.fid && data.features[i].properties.fid==land.fid) {
            itIs = data.features[i];
            break;
          }
        }
        data = itIs || data.features[0]; //the first one should be the latest one as sorted from db
      }
      let feature = this.$map.GeoJSONToFeatures(data,{
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      })[0];
      setTimeout(() => {
        this.$map.addFeaturesToLayer([feature], "SelectedFeatureLayer");
        setTimeout(() => {
          this.showLinkToLandButton(data, feature);
        },250);
      },250);
    } catch (error) {
      if (error.id=='not_found' || error.id=='no_content') {
      } else {
        this.alertError(error.message || 'Error from showFeatureInfo()');
      }
    }
  }

  showLinkToLandButton(data:IGeoJSON, feature:Feature) {
    let self = this;
    let info:any = {
      title: 'linkData',
      info: 'จะเชื่อมโยงข้อมูลกับแปลงนี้ไหม',
      popup: {
        style: "width:300px",
        position: this.$map.getFeatureCentroid(feature).map,
        offset: [0,-20],
        okText: 'yes',
        cancelText: 'no',
        methods: {
          doAction(answer:string) {
            if (answer=='accept') {
              self.doLinkData(data, feature);
            }
            this.closeMe();
          }
        },
        onClose: () => {
          this.$map.clearLayer('SelectedFeatureLayer');
        }
      },
      feature: feature
    }
    setTimeout(() => {
      this.$map.showInfoPopup(info.title, info.info, info.popup);
    }, 250);
  }

  linkData() {
    this.setMapAction({name:'linkData',params:{}});
  }

  async doLinkData(data:IGeoJSON, feature:Feature) {
    if (data.features) { //ensure to link to the first feature
      data = data.features[0];
    }
    let mapping = require("../../public/static/js/schemas").doae_mappping;
    let crops:any = {
      type_fk_g: {},
      genus_fk_g: {},
      crop_fk_g: {}
    };
    let props:any = {};
    let to, pn, pv;
    for (pn in this.userData) {
      to = mapping[pn];
      if (to) {
        pv = parseValue(this.userData[pn],to.dataType);
        if (to.name.match(/type_fk_g|genus_fk_g|crop_fk_g/)) {
          if (!crops[to.name][pv]) {
            if (pv) {
              try {
                let type = to.name.match(/type_fk/) ? 'type' : 
                           to.name.match(/genus_fk/) ? 'genus' : 'crop';
                let crop = await this.User.requestResource('mis/cropcode', 'GET', {
                  type: 'crop' + type,
                  name: pv
                });
                props[to.name] = crop[0].code;
                crops[to.name][pv] = crop[0].code;
              } catch (error) {}
            } else {
            }
          } else {
            props[to.name] = crops[to.name][pv];
          }
        } else if (to.name=='addr_aa5' && !!pv) {
          pv += '';
          props['addr_aa3'] = parseInt(pv.substring(0,2));
          props['addr_aa4'] = parseInt(pv.substring(0,4));
          props['addr_aa5'] = parseInt(pv);
        } else if (to.name=='irrigation') {
          props[to.name] = pv=='1' ? 'ในเขต' : pv=='2' ? 'นอกเขต' : null;
        } else if (to.name=='ownership') {
          props[to.name] = (pv==1 || pv==2) ? 'ของครัวเรือน' : 
                            pv==3 ? 'เช่า' : 
                            pv==4 ? 'อื่นๆ (ไม่ระบุ)' : null;
        } else {
          props[to.name] = parseValue(pv,to.dataType);
          if (to.name=='deed_type_g') {
            try {
              let deedTypes = await this.User.requestResource('mis/deed_type/' + pv);
              props[to.name] = deedTypes[0].name;
            } catch (error) {}
          }
        }
      }
    }
    data.properties = Object.assign(data.properties, props);
    if (data.properties.ssn_pk) {
      ['fssn_fk','farmer_ssn'].forEach((ssn) => {
        if (data.properties.hasOwnProperty(ssn) && 
          data.properties[ssn]!= data.properties.ssn_pk) {
          data.properties[ssn] = data.properties.ssn_pk;
        }
      });
    }
    data.featureOnMap = null; //IMPORTANT: so not to use data from the feature.
    this.mapInfo = this.buildMapInfo(data);
    feature.setProperties(data.properties); //20181224: add new properties to feature
    this.mapInfo.feature = feature;
    this.mapInfo.items.forEach((item, i) => {
      item.properties.forEach((prop, j) => {
        if (prop.source && props.hasOwnProperty(prop.name)) {
          prop.value = props[prop.name];
          prop.originalValue = null; // so that we can check what has changed in order to save it
        }
      });
    });

    this.toc = 'MAP_INFO';
    this.showDrawerLeft = true;
  }

  protected username: string = '';
  protected password: string = '';
  protected errorMessage: string = null;
  async login(token?:string) {
    try {
      if (!(token || (this.username && this.password))) {
        this.errorMessage = "Please enter user name and passworkd";
        return;
      }
      let user = new User();
      let data = await user.login(token || this.username,token ? null : this.password);
      if (!!data && isJsObject(data)) {
        if (data.link) {
          let linked: {[key:string] : any} = {};
          let sameFarmer:{[key:string] : any}[] = [];
          if (!isArray(data.link)) {
            data.link = [data.link];
          }
          let activityId = data.ACTIVITY_ID;
          data.link.forEach((link) => {
            let an3, an4, an5;
            let key = link.aag5 + '';
            if (key.substring(0,2)=='10') {
              an3 = link.province;
              an4 = 'เขต' + link.amphoe;
              an5 = 'แขวง' + link.tambon;
            } else {
              an3 = 'จ.' + link.province;
              an4 = 'อ.' + link.amphoe;
              an5 = 'ต.' + link.tambon;
            }
            let area = '';
            if (link.area_rai) {
              area = link.area_rai + ' ไร่';
            }
            if (link.area_ngan || link.area_sqwah) {
              area += ' ' + link.area_ngan + ' งาน';
            }
            if (link.area_sqwah) {
              area += ' ' + link.area_sqwah + ' ตร.วา';
            }
            area = area.trim();
            let farmer = '';
            if (link.name) {
              farmer = link.title + link.name + ' ' + link.surname;
            }
            linked[key] = linked[key] || {
              name: an5 + ' ' + an4 + ' ' + an3,
              results: []
            }
            linked[key].results.push(Object.assign(link, {
              status: link.orgc_ref ? 2 : 1,
              title: farmer,
              subTitle: 'เนื้อที่ ' + area,
              linked: link.orgc_ref ? ('ACTIVITY_ID: ' + link.orgc_ref) : 'ไม่ได้เชื่อมกับ ' + data.DEPARTMENT
            }));
          });
          delete data.link;
          this.LinkedLands = linked;
          //this.SameFarmerLands = sameFarmer;
          //this.ldShowSameFarmerLands = this.SameFarmerLands.length>0;
        } else {
          this.LinkedLands = {
            no_data: {
              name: 'ไม่พบแปลงที่เชื่อมโยงกับข้อมูลที่ส่งมา',
              results: []
            }
          }
        }
        this.ldShowLinkedLands = true;
        this.userData = data;
        this.toggleToc("LINK_DATA");
      }
      this.User = user;
      this.createFarmlandLayer();
    } catch (error) {
      console.log('login Failed: ' + error.message);
      this.showUserLogin();
    }
  };

  async logout() {
    try {
      await this.User.logout();
      this.WebSocket.disconnect();
      //this.closeToHome();
      this.goToHome();
      window.close();
    } catch (error) {
      console.log(error.message || "Error from logout()");
    }
  };

  closeToHome() {
    //this.$store.commit('notifyChange', {
    //  Page: 'home'
    //});
    let url, win;
    let app = this.$store.getters.Page;
    if (window.opener && window.opener.name=='GISagro') {
      url = ''; //so that page won't be reloaded
      if (window.opener[app]) {
        delete window.opener[app];
      }
    } else {
      url = window.location.protocol + '//' + 
            window.location.hostname + 
            (window.location.port ? ':' + window.location.port : '');
    }
    win = window.open(url, 'GISagro');
    window.close();
    win.focus();
  };
}